export var DataQueryBucketKey;
(function (DataQueryBucketKey) {
    DataQueryBucketKey["Root"] = "root";
    DataQueryBucketKey["ColumnGrandTotals"] = "columnGrandTotals";
    DataQueryBucketKey["ColumnSubTotals"] = "columnSubTotals";
    DataQueryBucketKey["RowGrandTotals"] = "rowGrandTotals";
    DataQueryBucketKey["RowSubTotals"] = "rowSubTotals";
    DataQueryBucketKey["GreatGrandTotals"] = "greatGrandTotals";
    DataQueryBucketKey["GreatSubTotals"] = "greatSubTotals";
    DataQueryBucketKey["LineRoot"] = "lineRoot";
    DataQueryBucketKey["LineRowGrandTotals"] = "lineRowGrandTotals";
    DataQueryBucketKey["LineRowSubTotals"] = "lineRowSubTotals";
})(DataQueryBucketKey || (DataQueryBucketKey = {}));
export const NO_TOTALS = {
    columnGrandTotalsEnabled: false,
    isColSubTotalsEnabled: false,
    isRowGrandTotalsEnabled: false,
    isRowSubTotalsEnabled: false,
};
export const ALL_TOTALS = {
    columnGrandTotalsEnabled: true,
    isColSubTotalsEnabled: true,
    isRowGrandTotalsEnabled: true,
    isRowSubTotalsEnabled: true,
};
export var ChartFamily;
(function (ChartFamily) {
    ChartFamily["Cartesian"] = "cartesian";
    ChartFamily["Polar"] = "polar";
    ChartFamily["Pivot"] = "pivot";
    ChartFamily["LineStackedColumn"] = "lineStackedColumn";
})(ChartFamily || (ChartFamily = {}));
export const DATA_SIZE_LIMIT = 100001;
//# sourceMappingURL=types.js.map